export interface PaymentPlanItem {
  id: number | null;
  concept: string; // e.g., "Drop fee", "Renewal fee"
  amount: number;
  currency: string;
  dueDate?: string; // ISO date string
  validForDays?: number;
  status: PaymentStatus;
  paidDate?: string; // ISO date string
  paymentMethod?: string; // e.g., "TRANSFER", "CARD", "CASH"
  invoiceReference?: string;
  description?: string;
  isRequired: boolean;
  isDisabled?: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PaymentPlan {
  id: number | null;
  contractId: number;
  items: PaymentPlanItem[];
  totalAmount: number;
  currency: string;
  createdAt: string;
  updatedAt: string;
}

export enum PaymentStatus {
  UNKNOWN = 'UNKNOWN',
  PAID = 'PAID',
  NOT_PAID = 'NOT_PAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PENDING = 'PENDING',
  OVERDUE = 'OVERDUE',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
}

export enum PaymentConcept {
  DROP_FEE = 'DROP_FEE',
  RENEWAL_FEE = 'RENEWAL_FEE',
  STORAGE_FEE = 'STORAGE_FEE',
  OTHER = 'OTHER',
}

export const PAYMENT_CONCEPT_LABELS: Record<PaymentConcept, string> = {
  [PaymentConcept.DROP_FEE]: 'payment.concept.drop_fee',
  [PaymentConcept.RENEWAL_FEE]: 'payment.concept.renewal_fee',
  [PaymentConcept.STORAGE_FEE]: 'payment.concept.storage_fee',
  [PaymentConcept.OTHER]: 'payment.concept.other',
};

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  [PaymentStatus.PAID]: 'payment.status.paid',
  [PaymentStatus.NOT_PAID]: 'payment.status.not_paid',
  [PaymentStatus.PARTIALLY_PAID]: 'payment.status.partially_paid',
  [PaymentStatus.PENDING]: 'payment.status.pending',
  [PaymentStatus.OVERDUE]: 'payment.status.overdue',
  [PaymentStatus.FAILED]: 'payment.status.failed',
  [PaymentStatus.REFUNDED]: 'payment.status.refunded',
  [PaymentStatus.UNKNOWN]: 'payment.status.unknown',
};

export const PAYMENT_STATUS_COLORS: Record<PaymentStatus, string> = {
  [PaymentStatus.PAID]: 'green',
  [PaymentStatus.NOT_PAID]: 'gray',
  [PaymentStatus.PARTIALLY_PAID]: 'yellow',
  [PaymentStatus.PENDING]: 'blue',
  [PaymentStatus.OVERDUE]: 'red',
  [PaymentStatus.FAILED]: 'red',
  [PaymentStatus.REFUNDED]: 'purple',
  [PaymentStatus.UNKNOWN]: 'gray',
};
